
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faq7yAelFmLTf543jOY2Z65p8oTozywGm6tGIC8mgc0g4gMeta } from "/codebuild/output/src2184713712/src/src/pages/faq.vue?macro=true";
import { default as menueaJ9qu_x1HmhE7CgIoK2p4rlqCkVGvwiZw6cG6UPjGgMeta } from "/codebuild/output/src2184713712/src/src/pages/menu.vue?macro=true";
import { default as index4fY5jvQGba60kmcnUKUVouLpDKl9vauUeTlYuexK_45UEMeta } from "/codebuild/output/src2184713712/src/src/pages/index.vue?macro=true";
import { default as contacty6KKg_nXvcpcH1cVlkdOzssPG1RDaizVHZEc3o1whYMMeta } from "/codebuild/output/src2184713712/src/src/pages/contact.vue?macro=true";
import { default as tutorialTi0wKaezfLiBS9MGUkG82uLTNXAvo3U5CwSwbh_K9eQMeta } from "/codebuild/output/src2184713712/src/src/pages/tutorial.vue?macro=true";
import { default as agreementuSWujjmpPcueUifdsnfimMtGkbxrFJwem4HtZ_67RbAMeta } from "/codebuild/output/src2184713712/src/src/pages/agreement.vue?macro=true";
import { default as about_45passkUE65LWNznnpPPzSfFC4n98EXB91NVaB_W2x556DFZQMeta } from "/codebuild/output/src2184713712/src/src/pages/about-pass.vue?macro=true";
import { default as indexZIEoDZ4qA1EP3fhaPtk0QY9k8ArHA16GDHosbHoDALIMeta } from "/codebuild/output/src2184713712/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93e1oz7E5rWoWdn_hD43_M6sVg7aIYQIGVvj3UyCkwicgMeta } from "/codebuild/output/src2184713712/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceVBKjeWcq6H4zgXUCZW5BDhofg2TTmDgl7edr6_45DzU1AMeta } from "/codebuild/output/src2184713712/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_934fihzElDqbuIokD4kIZaSm26kq_45Nrh_K_xnNszq9Na8Meta } from "/codebuild/output/src2184713712/src/src/pages/notice/[id].vue?macro=true";
import { default as indexT4SJ5WLVmuAQQ0tg2RmiYRh6mWpmxSBnRkpUW2S1KMwMeta } from "/codebuild/output/src2184713712/src/src/pages/coupon/index.vue?macro=true";
import { default as index__gktYUGRafpVZjkrufHqGWazlgWdfSsDW7nawrMLrAMeta } from "/codebuild/output/src2184713712/src/src/pages/mypage/index.vue?macro=true";
import { default as indexbyLJCshYEMtK36xXh7UAQPmr8UqMxkloVLyqedkzIgoMeta } from "/codebuild/output/src2184713712/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93KTT9RnPStj9kcw9iPuszV6TvaYnfFyQQAUhGNxAMB6kMeta } from "/codebuild/output/src2184713712/src/src/pages/parking/[id].vue?macro=true";
import { default as indexlaPwi6_45Z0_45fAZx_kTlIsNWdlKw76TpCySZG37Pi7GzkMeta } from "/codebuild/output/src2184713712/src/src/pages/history/index.vue?macro=true";
import { default as indexCS5r0RLKQbSUqUoUB5QFd4b0aqh8e52gEAS_45gwjzhYYMeta } from "/codebuild/output/src2184713712/src/src/pages/monthly/index.vue?macro=true";
import { default as indexs2A0ghfGAiwOtC3AZmz_45W7fIh6VcVD9toAXhYZdnC7oMeta } from "/codebuild/output/src2184713712/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexOT_EKiLmG691ypjzHTc980AtFAkcJQkPmqwe6SbDW5oMeta } from "/codebuild/output/src2184713712/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviS8GE5L_45PdK4_7QMl04Ur6XjP75RJs2mIBEvpIn9FskwMeta } from "/codebuild/output/src2184713712/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editEyHXUSIurR_XKnjixteNxPyGrvRBZ6b7pbW_ztvnjEQMeta } from "/codebuild/output/src2184713712/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementSFXlMNJUuhPNRn5zsYzgLNvejRYkJPRUHhF4j0PxqqQMeta } from "/codebuild/output/src2184713712/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexqe7Ch0ECpi5TGXEJedegX9MRIihbpmyR1dmqgVQqUMUMeta } from "/codebuild/output/src2184713712/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453d28E_45cSJbOMXl_45ahsiiaxZtZDtBMz5eatXIrwrDc2XdgMeta } from "/codebuild/output/src2184713712/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmKRPlJY1WG5BeAEfN0FwfmUEoZUMbAy7x8F1IAbPmK34Meta } from "/codebuild/output/src2184713712/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexCMXwN8drHVHb_UvKu_ieVWw0r0wKANzqRO__45vkDNC0UMeta } from "/codebuild/output/src2184713712/src/src/pages/card/create/index.vue?macro=true";
import { default as indexUVeM5h2I1ol92ITogbPiK_45ixBLzStgq3Zj_453CUasJSwMeta } from "/codebuild/output/src2184713712/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirm6kumN9cAXyRbAEXakO_7OGBE5K0GiocNFAI62f6b_wQMeta } from "/codebuild/output/src2184713712/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmCkcGvOl126ofQm6b5WRfUkwVzg5c4BuDcmdNbBMOMgAMeta } from "/codebuild/output/src2184713712/src/src/pages/card/create/confirm.vue?macro=true";
import { default as complete2KiV90ZlipSgse6zQOOARhE2Rj2KKgcwxiHu8UJC0y4Meta } from "/codebuild/output/src2184713712/src/src/pages/membership/complete.vue?macro=true";
import { default as registersZYBtv62L6UwWTmsXXheANG9Wxbwg0phzdAH55sSyC8Meta } from "/codebuild/output/src2184713712/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93dIghRjDAIVzrpi0VuZqoFfUlTYde6LxsgtHoaOsR_NQMeta } from "/codebuild/output/src2184713712/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmA_1JVbK_iJdglv97AZzqBFoxuWY7TK_45sK1nyTSuroZQMeta } from "/codebuild/output/src2184713712/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93f0fUxA9F_457iC939rsW2mGM5VdDT_45UWxb3WuDBG_KRFwMeta } from "/codebuild/output/src2184713712/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as index4p_45kBhV0BCh2_rC5Gq04q3DgHXhATvu__43nsIxqqWgMeta } from "/codebuild/output/src2184713712/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codesMM7dpCNAPhDNuvDawlemq1yZnIjBd0VxsyzqhZ5164Meta } from "/codebuild/output/src2184713712/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45code_45kxAGM7uDyjU5axFbKUT7PvBwDlwOdsVu9VZa18J5SIMeta } from "/codebuild/output/src2184713712/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completevybo_45djP55iNqPbv5ikTcT6viwxqI18RxUqBv1IaZgoMeta } from "/codebuild/output/src2184713712/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerqAxaiYLIjie2MPypesGuYoXyI01hHed2tFiudAH_459PcMeta } from "/codebuild/output/src2184713712/src/src/pages/contact-form/register.vue?macro=true";
import { default as completepmCQwmYLdu6X5WXhCm4SjOUrBOkrO7jCjClt2vKBd78Meta } from "/codebuild/output/src2184713712/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexq0sRQMotRP0l3B_45vF56CzGS1DAZRfcEp_456UKQYMFRVcMeta } from "/codebuild/output/src2184713712/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmXDplpzLfPOy0Y1ugDe1PISVQyNEgX2Wy9XrcBeue4fsMeta } from "/codebuild/output/src2184713712/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeCTccS3mR3gurgYBmk_mQwloHwWr9svp7HJQEekB32ucMeta } from "/codebuild/output/src2184713712/src/src/pages/reset-password/complete.vue?macro=true";
import { default as index9_60rsx2uuWuCTKvTGXdOM34MI2r2jOscLBfRLdREs4Meta } from "/codebuild/output/src2184713712/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93lEYZun_L0Z7IYXMVDrPceGdYkbUmHvfqa832WDhxzGQMeta } from "/codebuild/output/src2184713712/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completejONzj11Z3WBVVmHzp_7JtMDSIKIDmQUKYDXydTWNoIYMeta } from "/codebuild/output/src2184713712/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasOF_PMIMf5qaISg_7656DUYgzjTl_utaS_456Ki73j4X3sMeta } from "/codebuild/output/src2184713712/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplehlr6tKBPcjkDMXYEI4IzOWWQKUKCCtJnsl8shiLYrZ8Meta } from "/codebuild/output/src2184713712/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailvpYXy7cXx9c_d1BPDKF6ecLNwTqsqmgFhLXyuYTXt9YMeta } from "/codebuild/output/src2184713712/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmU72CxuxwwhgrJN_45H2imQoRyCmvW0RfPvjysq33HX_O4Meta } from "/codebuild/output/src2184713712/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentfFOsrVy3hOkEQeu9ET36_45vDWRLo1vYDprOJQNgUze0wMeta } from "/codebuild/output/src2184713712/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmMgJ7wJKG_XgD70vEzSYcFzQrxPjEJpCVkxqlaiARhdkMeta } from "/codebuild/output/src2184713712/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateN5SXghzVZZPivRSoqS_45UsDTd2MJjJwfIyUMqll8h4pwMeta } from "/codebuild/output/src2184713712/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeEVdPhiGtMADK1nlXDNJ7OqpGi5du3yiMVdIfy0YpuoUMeta } from "/codebuild/output/src2184713712/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeuoM7QGw5Glnrstq9XpS5ka4EYhk95pRyDSlOCNAXTLsMeta } from "/codebuild/output/src2184713712/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordSMDNONFGrFT3hB1NkKaGz6ub3NLv_45WuulOES6R0K_ekMeta } from "/codebuild/output/src2184713712/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliaspc9_45HwXaQY4g6tG2yokHh7HzTeIndhbAAshowGVuyGkMeta } from "/codebuild/output/src2184713712/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerysAqZYwdXAca9mvun84msiPqPUKIJ74ozBvBvf1u_PQMeta } from "/codebuild/output/src2184713712/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeV1b3L2nUqbv47T_45P86gtiF3RM75lN35V6N9k7Pu0teAMeta } from "/codebuild/output/src2184713712/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexxh56E7OuVD8dcR4DiIhcddhvNFMaoLoCgHW5JqvciB0Meta } from "/codebuild/output/src2184713712/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexGZMq_ckvyXNysgHOMy_QtzQlQZM1WkeW9kk_45YaCPZ6sMeta } from "/codebuild/output/src2184713712/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexxqAZOK712pljGyTyI93IRfURoIv5Klu8FVntxEe4NjQMeta } from "/codebuild/output/src2184713712/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexSUCcIhWDtaaE2iCTCWIw6vjos1QRDJk68ntTC7Y_45hTEMeta } from "/codebuild/output/src2184713712/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updatef_45WDQcKAGsr1ART_qyu15b6m__grYVrlilgaQTrJQA0Meta } from "/codebuild/output/src2184713712/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as complete93_GS4pH_cjolvmKoa_IiV7AI7R2JdT9uHcvXVEodjwMeta } from "/codebuild/output/src2184713712/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmx3cVpPAt0Y4k2_c7A_Cot4HdILy2vEvuRAU6JgcZQOUMeta } from "/codebuild/output/src2184713712/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexiWSftmvyiv4hl4SBdQkw0RaYmePyvend5O_45s6h4xQmEMeta } from "/codebuild/output/src2184713712/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as complete88g6GOcJjYJqRvRLuvgpm1brdDD1vWfzs0YM09_tcJwMeta } from "/codebuild/output/src2184713712/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateNLL9ejIOuGW6soe45Q_kCEBPPB4ca55Vg8spLObFynUMeta } from "/codebuild/output/src2184713712/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexDkPJ_NUDLfIPdYviy8lLsxKMYCynmyu2wbrQH1salxwMeta } from "/codebuild/output/src2184713712/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexwuaCe_45VHCmWwRSCTSDwppf3yiBHKfpnB13WKbb62asoMeta } from "/codebuild/output/src2184713712/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeqJxLUrCbiFIS84paRk4HW4vXPu3vgYEGwHGPsAEq2uMMeta } from "/codebuild/output/src2184713712/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as index3XoV9X4s4kUuKnxnM4_45TUOrJTLpmeefqvmxICVFLamsMeta } from "/codebuild/output/src2184713712/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeJ2_45SwyNuimEtCqa9YUijLRCRoHhnwCpSNHaBS0YijuYMeta } from "/codebuild/output/src2184713712/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as index6u8CP7NrKv_45UtXhqW1iPGVTxq7jPU6runKva9WpcJoMMeta } from "/codebuild/output/src2184713712/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexYskoGryC_45Xwot6Rxi79LZ3e_VaNCsRiBSFgdf_45nHigcMeta } from "/codebuild/output/src2184713712/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexE9i7fVl_IiRbCPwFIYfz36LJJh7HP__zku5a2V3OhzgMeta } from "/codebuild/output/src2184713712/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateU_453RjXlhUMnz7md17uUzIkdxq1xh2mBBJH9nJYVvGrsMeta } from "/codebuild/output/src2184713712/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirm6wtb61UHALTYWa5bghrSTZqcqW3reW_45ai1YxEd9fLUUMeta } from "/codebuild/output/src2184713712/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menueaJ9qu_x1HmhE7CgIoK2p4rlqCkVGvwiZw6cG6UPjGgMeta || {},
    component: () => import("/codebuild/output/src2184713712/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(index4fY5jvQGba60kmcnUKUVouLpDKl9vauUeTlYuexK_45UEMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src2184713712/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexT4SJ5WLVmuAQQ0tg2RmiYRh6mWpmxSBnRkpUW2S1KMwMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src2184713712/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src2184713712/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src2184713712/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src2184713712/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexlaPwi6_45Z0_45fAZx_kTlIsNWdlKw76TpCySZG37Pi7GzkMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src2184713712/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexs2A0ghfGAiwOtC3AZmz_45W7fIh6VcVD9toAXhYZdnC7oMeta || {},
    component: () => import("/codebuild/output/src2184713712/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexOT_EKiLmG691ypjzHTc980AtFAkcJQkPmqwe6SbDW5oMeta || {},
    component: () => import("/codebuild/output/src2184713712/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2184713712/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2184713712/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexCMXwN8drHVHb_UvKu_ieVWw0r0wKANzqRO__45vkDNC0UMeta || {},
    component: () => import("/codebuild/output/src2184713712/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src2184713712/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirm6kumN9cAXyRbAEXakO_7OGBE5K0GiocNFAI62f6b_wQMeta || {},
    component: () => import("/codebuild/output/src2184713712/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmCkcGvOl126ofQm6b5WRfUkwVzg5c4BuDcmdNbBMOMgAMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src2184713712/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: complete2KiV90ZlipSgse6zQOOARhE2Rj2KKgcwxiHu8UJC0y4Meta || {},
    component: () => import("/codebuild/output/src2184713712/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registersZYBtv62L6UwWTmsXXheANG9Wxbwg0phzdAH55sSyC8Meta || {},
    component: () => import("/codebuild/output/src2184713712/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmA_1JVbK_iJdglv97AZzqBFoxuWY7TK_45sK1nyTSuroZQMeta || {},
    component: () => import("/codebuild/output/src2184713712/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codesMM7dpCNAPhDNuvDawlemq1yZnIjBd0VxsyzqhZ5164Meta || {},
    component: () => import("/codebuild/output/src2184713712/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45code_45kxAGM7uDyjU5axFbKUT7PvBwDlwOdsVu9VZa18J5SIMeta || {},
    component: () => import("/codebuild/output/src2184713712/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completevybo_45djP55iNqPbv5ikTcT6viwxqI18RxUqBv1IaZgoMeta || {},
    component: () => import("/codebuild/output/src2184713712/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerqAxaiYLIjie2MPypesGuYoXyI01hHed2tFiudAH_459PcMeta || {},
    component: () => import("/codebuild/output/src2184713712/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmXDplpzLfPOy0Y1ugDe1PISVQyNEgX2Wy9XrcBeue4fsMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src2184713712/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeCTccS3mR3gurgYBmk_mQwloHwWr9svp7HJQEekB32ucMeta || {},
    component: () => import("/codebuild/output/src2184713712/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(index9_60rsx2uuWuCTKvTGXdOM34MI2r2jOscLBfRLdREs4Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2184713712/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completejONzj11Z3WBVVmHzp_7JtMDSIKIDmQUKYDXydTWNoIYMeta || {},
    component: () => import("/codebuild/output/src2184713712/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2184713712/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplehlr6tKBPcjkDMXYEI4IzOWWQKUKCCtJnsl8shiLYrZ8Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2184713712/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailvpYXy7cXx9c_d1BPDKF6ecLNwTqsqmgFhLXyuYTXt9YMeta || {},
    component: () => import("/codebuild/output/src2184713712/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmU72CxuxwwhgrJN_45H2imQoRyCmvW0RfPvjysq33HX_O4Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2184713712/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentfFOsrVy3hOkEQeu9ET36_45vDWRLo1vYDprOJQNgUze0wMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2184713712/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmMgJ7wJKG_XgD70vEzSYcFzQrxPjEJpCVkxqlaiARhdkMeta || {},
    component: () => import("/codebuild/output/src2184713712/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeEVdPhiGtMADK1nlXDNJ7OqpGi5du3yiMVdIfy0YpuoUMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2184713712/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeuoM7QGw5Glnrstq9XpS5ka4EYhk95pRyDSlOCNAXTLsMeta || {},
    component: () => import("/codebuild/output/src2184713712/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordSMDNONFGrFT3hB1NkKaGz6ub3NLv_45WuulOES6R0K_ekMeta || {},
    component: () => import("/codebuild/output/src2184713712/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2184713712/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerysAqZYwdXAca9mvun84msiPqPUKIJ74ozBvBvf1u_PQMeta || {},
    component: () => import("/codebuild/output/src2184713712/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeV1b3L2nUqbv47T_45P86gtiF3RM75lN35V6N9k7Pu0teAMeta || {},
    component: () => import("/codebuild/output/src2184713712/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src2184713712/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]